import {h, Fragment} from "preact"
import Products from "./Products"
import Toolbar from "./Toolbar"
import Pagination from "./Pagination"
import SelectedFilters from "./SelectedFilters"
import { wrapContent } from "./ContentWrapper"
import { InfiniteScroll } from "@nosto/preact"
import Loader from "./elements/Loader"
import NoResults from "./NoResults"
import { useState } from "preact/hooks"

export function SerpBody({ loading, foundProducts }) {
    const [ gridMode, setGridMode ] = useState(true)

    if (loading) return <Loader />
    return (
        foundProducts ? <>
            {window.innerWidth > 859 && <SelectedFilters />}
            <Toolbar gridMode={gridMode} setGridMode={setGridMode} />
            <Products gridMode={gridMode} />
            <Pagination />
        </> : <NoResults />
    )
}

export function SerpBodyInfiniteScroll({ loading, foundProducts }) {
    if (!foundProducts) return loading ? <Loader /> : <NoResults />
    return (
        <>
            <SelectedFilters />
            <Toolbar />
            <InfiniteScroll>
                <Products />
            </InfiniteScroll>
        </>
    )
}

// replace with following line to enable infinite scroll
// export default wrapContent("search", SerpBodyInfiniteScroll)
export default wrapContent("search", SerpBody)
